import {
  SchemaModel,
  StringType,
  NumberType,
  ArrayType,
  DateType,
  ObjectType,
  BooleanType,
  MixedType
} from 'schema-typed';

const SchemaTyped = {
  Model: SchemaModel,
  Types: {
    StringType,
    NumberType,
    ArrayType,
    DateType,
    ObjectType,
    BooleanType,
    MixedType
  }
};

export default SchemaTyped;
